export default "/workshops";
